// BYOB Tabs Fix - Add this to fix step 3 navigation for Buy 3
(function() {
  'use strict';
  
  // Wait for main BYOB script to load
  setTimeout(function() {
    // Override goToStep function to work with tab-specific content
    const originalGoToStep = window.goToStep;
    
    window.goToStep = function(step, shouldScroll = false) {
      const wrapper = document.querySelector('.byob-wrapper');
      if (!wrapper) return;
      
      const currentTab = wrapper.dataset.currentTab || 'buy2';
      
      // Update step navigation in bottom box
      document.querySelectorAll('.byob-box-step').forEach(nav => {
        const navStep = parseInt(nav.dataset.boxStep);
        if (navStep < step) {
          nav.classList.add('completed');
          nav.classList.remove('active');
        } else if (navStep === step) {
          nav.classList.add('active');
          nav.classList.remove('completed');
        } else {
          nav.classList.remove('active', 'completed');
        }
      });
      
      // Update step content visibility - ONLY show current step within active tab
      const activeTabContent = document.querySelector('.byob-tab-content[data-tab-content="' + currentTab + '"]');
      if (activeTabContent) {
        const tabStepContents = activeTabContent.querySelectorAll('.byob-step-content');
        tabStepContents.forEach(content => {
          const contentStep = parseInt(content.dataset.stepContent);
          if (contentStep === step) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        });
      }
      
      // Scroll if requested
      if (shouldScroll && step <= 3) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };
    
    // Fix auto-navigation for step 2 -> step 3 in Buy 3
    document.addEventListener('productAdded', function(e) {
      const wrapper = document.querySelector('.byob-wrapper');
      if (!wrapper) return;
      
      const maxItems = parseInt(wrapper.dataset.maxItems) || 2;
      const bundleMode = wrapper.dataset.mode || 'step';
      const targetStep = e.detail.targetStep;
      
      if (bundleMode === 'step') {
        if (targetStep === 1 && maxItems >= 2) {
          setTimeout(() => window.goToStep(2), 500);
        } else if (targetStep === 2 && maxItems >= 3) {
          setTimeout(() => window.goToStep(3), 500);
        }
      }
    });
    
  }, 1000);
})();
